export default __webpack_public_path__ + "static/media/tutorial-install-bot-1.e9b30d4b.png";